import { ApolloError } from '@apollo/client';
import { logger } from 'logging-utils';
import policiesService from '../../services';
import PoliciesStore from '../../store/policies';
import ProfileStore, { initNewProfile } from '../../store/profiles';
import PoliciesProfileUIStateStore from '../../store/policies-profile-ui';
import {
  mergePoliciesChanges,
  prepareProfileInput,
} from '../policies-profile-actions/policy-state-actions';
import { snapshot } from 'valtio';
import {
  setCreateNewProfileInProgress,
  setGeneralPoliciesPageError,
} from '../policies-selection-ui-actions/policies-selection-ui-actions';

export default async function saveAsNewProfileAction(): Promise<void> {
  try {
    setCreateNewProfileInProgress(true);
    PoliciesProfileUIStateStore.createNewProfileInProgress = true;
    const policiesStore = snapshot(PoliciesStore);
    const profileStore = snapshot(ProfileStore);
    if (!profileStore.profileInContext) {
      logger.error('No profile in context');
      return;
    }
    const { profileId } = profileStore.profileInContext;
    const dirtyPolicies = policiesStore.dirtyPolicies || {};
    const dirtyPoliciesList = prepareProfileInput(dirtyPolicies);

    const { profile } = await policiesService.addNewProfile.execute({
      profileId,
      profileName: profileStore.newProfile.payload.profileName
        .toLowerCase()
        .trimStart()
        .trimEnd(),
      active: profileStore.newProfile.payload.active,
      policies: dirtyPoliciesList,
    });

    mergePoliciesChanges(dirtyPolicies);

    const activeProfileId = profileStore.newProfile.payload.active
      ? profile.profileId
      : profileStore.activeProfileId;
    ProfileStore.activeProfileId = activeProfileId;
    ProfileStore.profileInContext = profile;
    ProfileStore.profiles = [...profileStore.profiles, profile].map(p => {
      return {
        ...p,
        active: p.profileId === activeProfileId,
      };
    });

    ProfileStore.newProfile = {
      ...initNewProfile,
    };

    PoliciesStore.dirtyPolicies = undefined;
    PoliciesProfileUIStateStore.createNewProfileInProgress = false;
    PoliciesProfileUIStateStore.showSaveAsModal = false;
    PoliciesProfileUIStateStore.disableSavePoliciesButton = true;
  } catch (error) {
    logger.error('save as new profile error', { error });
    if (error instanceof ApolloError) {
      setNewProfileResponseErorMessage(
        error.message.replace('GraphQL error: ', ''),
      );
      return;
    }
    setGeneralPoliciesPageError({
      errorTitle: 'Save As New Profile Failed!',
      errorMsg: 'Failed to load new profile content, please try again later.',
    });
  } finally {
    setCreateNewProfileInProgress(false);
  }
}

export const setNewProfileResponseErorMessage = (
  responseErorMessage: string,
) => {
  ProfileStore.newProfile.responseErorMessage = responseErorMessage;
};
